import React, { useContext, useState, useCallback, useRef } from 'react';
import Webcam from 'react-webcam';
import styled from 'styled-components';
import { DatabaseContext } from '../../contexts/DatabaseContext';
import { UserContext } from '../../contexts/UserContext';
import { Button } from '../../components/ui/forms/Button';
import { PatronContext } from '../../contexts/PatronContext';
import { PaneContext } from '../../contexts/PaneContext';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import ReplayIcon from '@material-ui/icons/Replay';
import PublishIcon from '@material-ui/icons/Publish';
import ReactCrop from 'react-image-crop';

const Camera = () => {
  const { patron, uploadPhoto} = useContext(PatronContext);
  const { toggleCamera, previewPanePhoto, updatePreviewPane } = useContext(PaneContext);
  const [photo, setPhoto] = useState(null);
  const webcamRef = useRef(null);
  const { apiUrl } = useContext(DatabaseContext);
  const { Site } = useContext(UserContext);



  
  const toFile = (dataUrl, filename) => {
    if (dataUrl) {
      let arr = dataUrl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    }
  };

  const capture = useCallback(() => {
    const img = webcamRef.current.getScreenshot();
    setPhoto(img);
  }, [webcamRef]);

  const save = () => {
    const file = toFile(photo, 'photo.jpg');
    uploadPhoto(patron.externalID, file).then((photoUrl) => {
      toggleCamera();
      updatePreviewPane(photo);
      setPhoto(previewPanePhoto);
    })
    setPhoto(`${apiUrl}/uploads/${Site.siteCode}/${patron.externalID}.jpg`);;
  };

  const undo = async () => {
    setPhoto(null);
  };

  return (
    <Container>
      <Button
        colour='error'
        onClick={toggleCamera}
        startIcon={<ArrowBackIcon />}
        style={{ alignSelf: 'flex-start', marginBottom: '2rem' }}
      >
        Go back
      </Button>

      <CamContainer>
        {photo ? (
          <img src={photo} alt={`${patron.firstName} ${patron.lastName}`} />
        ) : (
          <Webcam
            audio={false}
            width={380}
            height={450}
            ref={webcamRef}
            screenshotFormat='image/jpeg'
            minScreenshotHeight={328}
            minScreenshotWidth={247}
            videoConstraints={{
              width: 247,
              height: 328,
              facingMode: 'user',
            }}
          />
        )}
      </CamContainer>
      {!photo ? (
        <Button
          colour='success'
          onClick={capture}
          startIcon={<PhotoCameraIcon />}
        >
          Take Photo
        </Button>
      ) : (
        
        <div style={{ display: 'flex' }}>
          
          <Button
            colour='info'
            onClick={undo}
            startIcon={<ReplayIcon />}
            margin='0 1rem 0 0'
          >
            Retake
          </Button>
          <Button colour='success' onClick={save} startIcon={<PublishIcon />}>
            Upload
          </Button>
        </div>
      )}
    </Container>
  );
};

const Container = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CamContainer = styled.div`
  margin-bottom: 2rem;
  border: 1px solid;
  border-radius: 5px;
`;

export default Camera;
